// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-up-down.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/chevron-up-down'

import { Icon, type IconComponentProps } from '../icon'

export const ChevronUpDownIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
